export const en = {
    'block-errors': {
        one: 'Block contains {count} error',
        some: 'Block contains {count} errors',
        many: 'Block contains {count} errors',
        none: 'Block contains {count} errors'
    },
    'one-block-error': 'Block contains an error'
};
